import React from 'react'
import { Imgix } from '@elements'

export const WYSIWYG = ({
  wysiwyg,
  wysiwygHeading,
  wysiwygSubheading,
  link,
  image,
}) => {
  return (
    <div>
      {image && (
        <Imgix
          src={image.mediaItemUrl}
          alt={image.altText}
          className="w-24 pb-12 mx-auto lg:w-40"
        />
      )}
      {wysiwygHeading && (
        <h2 className="font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
          {wysiwygHeading}
        </h2>
      )}
      {wysiwygSubheading && <p>{wysiwygSubheading}</p>}
      <div
        dangerouslySetInnerHTML={{ __html: wysiwyg }}
        className={`prose prose-lg lg:prose-2xl mx-auto ${wysiwygHeading &&
          `mt-12`}`}
      ></div>
    </div>
  )
}
